import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'paragraph-please-complete';

const validator = () => null;

const vFParams = {
  paragraph: 'Please complete the Post Change Review for the CRQ.',
  fieldId,
};

const paragraphPleaseComplete = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { paragraphPleaseComplete };
